module.exports = __webpack_public_path__ + "img/sanofi.9c0d3bde.png";